// Import DC and dependencies

d3 = require("d3");
crossfilter = require("crossfilter");
module.exports = require("./dc");



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/dc/index.js
// module id = 101
// module chunks = 0